import { Component, Input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-saving-files',
    templateUrl: './saving-files.component.html',
    standalone: true,
    imports: [
        MatIconButton,
        MatIcon,
    ],
    styleUrls: ['./saving-files.component.scss']
})
export class SavingFilesComponent {
  @Input({required: true}) formCtrl!: FormControl;
  selectedFiles: any[] = [];

  onFilesSelected(event: Event): void {
      const { files } = event.target as HTMLInputElement;
      if (!files || files.length === 0) {
          return;
      }

      for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = (e: any) => {
              this.selectedFiles.push({
                  file,
                  preview: e.target.result,
                  type: file.type
              });
          };

          reader.readAsDataURL(file); // Чтение файла как Data URL для предпросмотра
      }

      this.formCtrl.setValue(files);// Запись в форму
  }

  removeFile(index: number): void {
      this.selectedFiles.splice(index, 1); // Удаление файла из списка предпросмотра

      // Получаем текущее значение FormControl и преобразуем в массив
      const currentFiles = Array.from(this.formCtrl.value as FileList);

      // Удаляем файл из массива
      const updatedFiles = currentFiles.filter((_, i) => i !== index);

      // Создаём новый FileList из массива
      const newFileList = this.createFileList(updatedFiles);

      // Обновляем значение FormControl
      this.formCtrl.setValue(newFileList);
  }

  // Вспомогательная функция для создания FileList из массива файлов
  createFileList(files: File[]): FileList {
      const dataTransfer = new DataTransfer();
      files.forEach(file => dataTransfer.items.add(file));
      return dataTransfer.files;
  }
}
